import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import Moment from 'moment';
import {Dropdown} from 'components/Dropdown/Dropdown';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import Translate from '../../components/translate';
import * as ProjectActionType from 'Projects/constants';
import * as RequestTypes from 'Request-Types/constants';
import * as AuthActionType from 'Auth/constants';
import * as PunchListActionType from '../constants';
import { AppSettings } from '../../constants';
import Jwt from '../../../src/helper/interceptors';
import { ObjToParam, MapResponse } from '../../../src/helper/helper-api';

class AddPunchList extends Component {
  static propTypes = {
    location: PropTypes.object,
    onSelectedLot: PropTypes.func,
    onSelectedStatus: PropTypes.func,
    history: PropTypes.object,
    dispatch: PropTypes.func,
    RFSStore: PropTypes.object,
    projectList: PropTypes.array,
    requestTypeList: PropTypes.array,
    userList: PropTypes.array,
    adminSelectList: PropTypes.array,
    lots: PropTypes.array
  }

  constructor(props) {
    super(props);
    this.state = {
      project: null,
      lot: null,
      requestType: null,
      user: null,
      projectList: props.projectList,
      lots: props.lots,
      requestTypeList: props.requestTypeList,
      userList: props.userList,
      isFetchingProject: false,
      isFetchingLot: false,
      isFetchingRequestType: false,
      isFetchingUser: false,
      check: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.projectList) {this.setState({isFetchingProject: false});}
    if (nextProps.lots) {this.setState({isFetchingLot: false});}
    if (nextProps.requestTypeList) {this.setState({isFetchingRequestType: false});}
    if (nextProps.userList) {this.setState({isFetchingUser: false});}
  }

  fetchProjectList = () => {
    this.setState({
      isFetchingProject: true
    });
    this.props.dispatch({
      type: ProjectActionType.SELECT_LIST_PROJECT_ASYNC,
      params: {
        param: { searchKey: '', selectedValue: '' }
      },
      callback: () => {
        this.setState({ isFetchedProject: true });
      }
    });
  }

  fetchLots = () => {
    if (this.state.project) {
      this.setState({
        isFetchingLot: true
      });
      this.props.dispatch({
        type: ProjectActionType.SELECT_LIST_LOT_ASYNC,
        params: {
          id: this.state.project.value,
          searchKey: '',
          selectedValue: '',
          setDefaultSelected: false
        },
        callback: () => {
          this.setState({ isFetchedLot: true });
        }
      });
    }
  }

  fetchRequestType = () => {
    this.setState({
      isFetchingRequestType: true
    });
    this.props.dispatch({
      type: RequestTypes.SELECT_LIST_ITEM_ASYNC,
      params: {
        searchKey: '',
        selectedValue: '',
        isBlueTape: true
      }
    });
  }

  fetchUser = () => {
    this.setState({
      isFetchingUser: true
    });
    if (this.state.check) {
      this.props.dispatch({
        type: AuthActionType.SELECT_LIST_ADMIN_SUPER_ADMIN_ASYNC,
        params: {
          searchKey: '',
          selectedValue: ''
        }
      });
    } else {
      if (this.state.project) {
        this.props.dispatch({
          type: ProjectActionType.GET_LIST_USER_ASYNC,
          params: {
            projectId: this.state.project.value
          }
        });
      }
    }
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    }, () => {
      if (name === 'project') {
        var user = this.state.project.extensionValue;
        // user['_$visited'] = true;
        this.setState({
          lot: null,
          user: user
        });
      }
    });
  }

  onChecked = () => {
    this.setState({
      check: !this.state.check
    });
  }

  onSubmit = () => {
    // alert('submit')
    const {project, lot, requestType, user} = this.state;
    const params = {
      projectId: project.value,
      lotId: lot.value,
      requestTypeId: requestType.value,
      isPunchList: true,
      managedByUserId: user.value
    };
    // console.log(params, 'params')
    // return Jwt(AppSettings.CURRENT_SITE_URI)
    // .post('/api/punch-lists', params)
    // .then(response => {
    //   return MapResponse(response);
    // })
    // .catch(error => {
    //   var response = error.response;
    //   return MapResponse(response);
    // });
    this.props.dispatch({
      type: PunchListActionType.CREATE_PUNCH_LIST_ASYNC,
      params,
      callback: (punchListRefNo) => {
        this.props.history.push(`/punch-lists/${punchListRefNo}/add`);
      }
    });
  }

  render() {
    const {project, lot, requestType, user} = this.state;
    console.log('Blue Tape add')
    const disable = !project || !lot || !requestType || !user;
    return <div className='add-rfs'>
      <div className='page-title clearfix'>
        <h2 className='pull-left'>Add new blue tape
        {/* <Translate translateKey='punchlist' /> */}
        </h2>
      </div>
      <ul className='breadcrumb'>
        <li><Link to={'/punch-lists'}>
          Blue Tapes
        {/* <Translate translateKey='punchlist' capitalize plurals/> */}
        </Link></li>
        <li className='breadcrumb-siteone-li'>Add new blue tape
        {/* <Translate translateKey='punchlist' /> */}
        </li>
      </ul>
      <div className='box-form-siteone'>
        <div className='box-form-body'>
          <p className='col-sm-12' style={{opacity: .6}}>Specify the <Translate translateKey='lot' /> that requires service</p>
          <div className='form-group'>
            <label className='col-md-12'><Translate translateKey='project' capitalize /> <span className='text-danger'>*</span></label>
            <div className='col-md-6'>
              <Dropdown
                filter={true}
                onChange={ref => {this.onSelectChange(ref, 'project');}}
                className='filestring-dropdown filter-dropdown'
                optionLabel='text'
                placeholder='-- Please select'
                style={{width: '100%'}}
                options={this.state.isFetchedProject ? this.props.projectList : [{...this.state.project}]}
                loading={this.state.isFetchingProject}
                name='projectList'
                onRemote={this.fetchProjectList}
                value={project}
              />
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-12'><Translate translateKey='lot' capitalize /> <span className='text-danger'>*</span></label>
            <div className='col-md-6'>
              <Dropdown
                filter={true}
                onChange={ref => {this.onSelectChange(ref, 'lot');}}
                className='filestring-dropdown filter-dropdown'
                placeholder='-- Please select'
                style={{width: '100%'}}
                options={this.state.isFetchedLot ? this.props.lots : [{...this.state.lot}]}
                disabled={!this.state.project}
                loading={this.state.isFetchingLot}
                onRemote={this.fetchLots}
                optionLabel='text'
                value={lot}
              />
            </div>
            {lot &&
            <div className='col-md-12' style={{marginTop: -10, marginBottom: 15}}>
              <span>Original COE: </span>
              {lot.extensionValue.coe && lot.extensionValue.coe !== 'null'
                ? <span>{Moment(lot.extensionValue.coe).format('MM/DD/YYYY')}</span>
                : <span style={{opacity: .5}}>(Not specified)</span>
              }
            </div>
            }
          </div>
          <div className='form-group'>
            <label className='col-md-12'>Request type <span className='text-danger'>*</span></label>
            <div className='col-md-6'>
              <Dropdown
                filter={true}
                onChange={ref => {this.onSelectChange(ref, 'requestType');}}
                className='filestring-dropdown filter-dropdown'
                placeholder='-- Please select'
                options={this.props.requestTypeList}
                loading={this.state.isFetchingRequestType}
                style={{width: '100%'}}
                optionLabel='text'
                onRemote={this.fetchRequestType}
                value={requestType}
              />
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-12'>RFS managed by <span className='text-danger'>*</span></label>
            <div className='col-md-6'>
              <Dropdown
                filter={true}
                onChange={ref => {this.onSelectChange(ref, 'user');}}
                className='filestring-dropdown filter-dropdown'
                placeholder='-- Please select'
                onRemote={this.fetchUser}
                options={this.state.check ? this.props.adminSelectList : this.props.userList}
                loading={this.state.isFetchingUser}
                disabled={!this.state.project && !this.state.check}
                value={user}
                optionLabel='text'
                style={{width: '100%', marginBottom: 0}}
              />
              <CheckBoxSingle
                style={{marginTop: 0, marginBottom: 20}}
                checked={this.state.check}
                ref={c => { this.check = c; }}
                name='checkAdmin'
                label='I want to assign this request to admin'
                className='checkbox-default noteTitle'
                onChecked={this.onChecked} />
            </div>
          </div>
          <div className='form-group'>
            <div className='col-sm-12'>
              <button className='btn btn-primary btn-siteone-default btn-wo-edit' onClick={() => {this.props.history.push('/punch-lists');}}>Cancel</button>
              <button className='btn btn-siteone' style={{marginLeft: 10}} disabled={disable} onClick={this.onSubmit}>Start your walk</button>
            </div>
          </div>
          <div className='clearfix'/>
        </div>
      </div>
    </div>;
  }
}

const mapStateToProps = (state) => {
  return {
    projectList: state.ProjectStore.ProjectList,
    lots: state.ProjectStore.LotList,
    requestTypeList: state.RequestTypeStore.ItemList,
    userList: state.ProjectStore.UserSelectList,
    adminSelectList: state.authReducer.adminSelectList
  };
};

export default connect(mapStateToProps)(AddPunchList);



// WEBPACK FOOTER //
// ./src/Punch-List/Containers/add-punch-list.js